import IconsetWidget from './iconset_widget';
export default IconsetWidget;
